// Mongo Constants
// Masao's Org > Project 0 > App Services
// export const APP_ID = 'application-0-ngfpk'
export const APP_ID = 'data-gdrzl'

export const USER_DATA_CLUSTER_NAME = 'Cluster0'
export const USER_DATA_DATABASE_NAME = 'intrinsic'
export const USER_DATA_COLLECTION_NAME = 'user_data'

export const CACHE_COLLECTION = 'cache'
export const EXAMPLE_COLLECTION = 'example'
export const TEST_COLLECTION = 'test'
export const USER_COLLECTION = 'user'
export const USER_EXAMPLE_COLLECTION = 'user_example'

export const STOCK_DATA_COLLECTION_NAME = 'stock_data'
export const SYMBOLS_COLLECTION_NAME = 'symbols'
export const QUOTES_COLLECTION_NAME = 'quotes'

// Google Constants
export const GOOGLE_CLIENT_ID =
  '534761462171-n2rrsttbv43b91rchrmd74csps3j5loq.apps.googleusercontent.com'

// Browser Storage
export const STORAGE_GOOGLE_USER = 'google_user'
export const STORAGE_EMAIL_USER = 'email_user'
